/* Presentation only: the same game works inline and in a native modal. */
(() => {
  if(customElements.get('kg-cristal-display'))return;
  class CrystalDisplay extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.abort=new AbortController();
      this.dialog=this.querySelector('dialog');this.launcher=this.querySelector('.kg-launcher');
      this.closeButton=this.querySelector('.kg-popup-close');
      this.key='kg-cristal-popup:'+this.dataset.campaign;
      const on=(node,event,handler)=>node.addEventListener(event,handler,{signal:this.abort.signal});
      on(this.launcher,'click',()=>this.openPopup());on(this.closeButton,'click',()=>this.closePopup());
      on(this.dialog,'close',()=>this.afterClose());
      on(this,'kg:close',()=>this.closePopup());
      on(this.dialog,'cancel',e=>{e.preventDefault();this.closePopup();});
      on(this.dialog,'click',e=>{
        const r=this.dialog.getBoundingClientRect();
        if(e.target===this.dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))this.closePopup();
      });
      const section=this.closest('.shopify-section');
      if(section){
        on(section,'shopify:section:select',()=>{if(this.dataset.mode==='popup')this.openPopup();});
        on(section,'shopify:section:deselect',()=>this.closePopup());
      }
      this.configure();
    }
    configure(){
      clearTimeout(this.timer);
      if(this.dialog.open)this.dialog.close();
      this.afterClose();
      const popup=this.dataset.mode==='popup';
      this.dialog.dataset.modal=String(popup);
      this.closeButton.hidden=!popup;
      this.launcher.hidden=!popup||this.dataset.trigger==='auto'||this.dataset.launcher==='off';
      if(!popup){this.dialog.setAttribute('role','presentation');this.dialog.removeAttribute('aria-label');this.dialog.setAttribute('open','');return;}
      this.dialog.removeAttribute('role');this.dialog.setAttribute('aria-label',this.querySelector('kg-cristal')?.t?.('popup_label')||'Descubre tu descuento Kinegun');
      if(globalThis.Shopify?.designMode){this.openPopup();return;}
      if(this.dataset.trigger!=='manual'&&this.canAutoOpen()){
        const seconds=Math.max(0,Math.min(60,Number(this.dataset.delay)||0));
        this.timer=setTimeout(()=>{if(this.isConnected&&this.canAutoOpen())this.openPopup();},seconds*1000);
      }
    }
    canAutoOpen(){
      if(this.dataset.frequency==='always')return true;
      if(this.shown)return false;
      try{
        const storage=this.dataset.frequency==='day'?localStorage:sessionStorage;
        const previous=Number(storage.getItem(this.key));
        return !previous||(this.dataset.frequency==='day'&&Date.now()-previous>=86400000);
      }catch{return true;}
    }
    openPopup(){
      if(this.dataset.mode!=='popup'||this.dialog.open)return;
      // Avoid overlapping another native modal (cart, consent, or another campaign).
      if(document.querySelector('dialog:modal'))return;
      clearTimeout(this.timer);this.returnFocus=document.activeElement;
      this.dialog.showModal();document.documentElement.classList.add('kg-popup-open');
      this.closeButton.focus({preventScroll:true});
      this.querySelector('kg-cristal')?.resizeCanvas();
      this.shown=true;
      if(!globalThis.Shopify?.designMode&&this.dataset.frequency!=='always'){
        try{(this.dataset.frequency==='day'?localStorage:sessionStorage).setItem(this.key,String(Date.now()));}catch{}
      }
    }
    closePopup(){if(this.dataset.mode==='popup'&&this.dialog.open){this.dialog.close();this.afterClose();}}
    afterClose(){
      if(this.dialog?.open&&this.dataset.mode==='popup')return;
      if(!document.querySelector('kg-cristal-display dialog[data-modal="true"][open]'))document.documentElement.classList.remove('kg-popup-open');
      if(this.returnFocus?.isConnected){this.returnFocus.focus({preventScroll:true});this.returnFocus=null;}
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();if(this.dialog?.open)this.dialog.close();this.afterClose();this.ready=false;}
  }
  customElements.define('kg-cristal-display',CrystalDisplay);
})();